<template>
  <div class="intro-content">
    <v-container>
      <!-- Page 1 -->
      <h1>{{ head1 }}</h1>
      <p>{{ text1 }}</p>
      <h2 style="text-align:left;">{{ head1_1 }}</h2>
      <ul>
        <li>{{ list1_1_1 }}</li>
				<li>{{ list1_1_2 }}</li>
      </ul>
      <h2 style="text-align:left;">{{ head1_2 }}</h2>
      <ul>
        <li>{{ list1_2_1 }}<b>{{ list1_2_1_2 }}</b>{{ list1_2_1_3 }}</li>
				<p>{{ list1_2_1_5 }}</p>
        <li>{{ list1_2_2 }}</li>
				<li>{{ list1_2_3 }}</li>
      </ul>
    </v-container>
  </div>
</template>

<script>
import { authTokenService } from '@/services/authTokenService.js';
import { CONSTANTS } from '../../common/constants';
import { answerService } from '../../services/answerService';
import { surveyService } from '../../services/surveyService';
import { utilityService } from '../../services/utilityService';
export default {
  data: () => ({
    activeId: Number,
    surveyType: Number,
    head1: "What’s New?",
    text1: "There are no major changes to the survey for this cycle, but the survey website has more functionality.",
    head1_1: "Specific Changes from Volume 73 to Volume 74",
    list1_1_1:
      "An error check has been added between the higher education and other nonprofit amounts reported on question 8 and the R&D conduct and plant  totals on the Federal S&E Support module questions 18 and 19. There are legitimate reasons why the amounts may be different, but the totals on questions 18 and 19 should be within 12% of the amounts reported on question 8.",
		list1_1_2:
			"The standalone supplemental question has been added at the end of the survey for Volume 73 has been retained, just updated to asks agencies to report R&D and R&D plant obligations from the CHIPS and Science Act, the Inflation Reduction Act, and the Infrastructure Investment and Jobs Act in FYs 2024 and 2025. This is the only place where these crosscuts are specifically collected. Any R&D from these three acts should be included in the total R&D and R&D plant obligations data reported throughout this survey.",
    head1_2: "Website Changes",
    list1_2_1:
      "For the Federal Science and Engineering (S&E) Support module questions, traditionally all higher education and other nonprofit institutions present on the previous year’s survey have been retained in the current survey. For Volume 74, only institutions with funds reported in the prior volume have been retained. Institutions with zero funds have been removed. If you would prefer to have ",
    list1_2_1_2:
      "all",
    list1_2_1_3:
      " institutions removed, please e-mail the support team.",
    list1_2_1_4:
      "",
		list1_2_1_5:
			"",
		list1_2_2:
			"The Print button that was on the navigation bar has been removed. To get a copy of the data you saved, download the data into an Excel spreadsheet through the link in the Survey Tools section on the survey Home page.",
		list1_2_3:
		"A History of the Survey PDF has been added to the Reference Materials section."
  }),
  mounted () {
    const me = this;
    me.activeId = authTokenService.getActiveSurveyId();
    me.surveyType = surveyService.getSurveyType(this.activeId);

    surveyService.getSurveyType(this.activeId).then(function (response) {
			if (response && response.data) {
        me.surveyType = response.data;
        return me.surveyType;
      }
		})
		.catch(function (e) {
			console.log(e);
			console.log("Error loading survey type in Intro section")
			throw e;
    });
  },
  methods: {
    checkSurveyType: function () {
      if (this.surveyType === utilityService.getSurveyTypes().Standard) {
        // Do this for Standard version
      } else if (this.surveyType === utilityService.getSurveyTypes().DOD) {
        // Do this for DOD version
      }
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 22pt; /*TODO learn how to share via default_intros.css */
  font-weight: bold;
  margin-bottom: 12pt;
  margin-top: 12pt;
}
h2 {
  font-size: 20pt; /*TODO learn how to share via default_intros.css */
  font-weight: bold;
}
.left {
  text-align: left;
}
.centered {
  text-align: center;
}
ul,
p {
  text-align: left;
}
p {
  font-size: 12pt;
  font-weight: normal;
}
li {
  margin-bottom: 10pt;
}
.intro-content {
  color: #000;
  max-width: 750px; /* TODO: discuss w/team; make a global */
}
.bordered {
  border: #000;
  border-width: 1px;
}
.header {
  font-weight: bold;
  color: #13314f;
  font-size: 14px;
  margin: 0;
}
table {
  background-color: rgb(252, 252, 252);
  width: 100%;
  text-align: left;
  border-spacing: 0;
  border: 1px solid black;
  border-collapse: collapse;
}
th {
  text-align: center;
  border: 1px solid black;
  padding: 15px;
}
th.bottom {
  vertical-align: bottom;
}
.marginleft {
  margin-left: 5px;
}
td {
  border: 1px solid black;
  padding: 10px;
}
td.center {
  text-align: center;
  border: 1px solid black;
}
td.top {
  vertical-align: top;
}
ul{
  margin-left: 25pt;
}
</style>
